import * as React from 'react';
import { connect } from 'react-redux';
import * as POIModule from './../../../Modules/POIModule';
import * as HistoryModule from './../../../Modules/HistoryModule';
import * as MapModule from 'Modules/MapModule';
import { withTranslation  } from 'react-i18next';
// import './PoiManagement.css';

export type State = {
    //
};
export type ConnectedProps = {
    poiStore: POIModule.Types.POIStore;
    t?: (key: string) => string;
};

export type DispatchedProps = {
    getPoiList: Function;
    addPoi: Function;
    deletePoi: Function;
    setActivePoi: Function;
    showPoiDetails: Function;
    setMapCenter: Function;
    setMapZoom: Function;
};

export type Props = {
    title: string;
    zone: HistoryModule.EnumTypes.ZonesViewType;
};

class POI extends React.Component<Props & ConnectedProps & DispatchedProps, State> {
    constructor(props: Props & ConnectedProps & DispatchedProps) {
        super(props);
        this.handlePoiElementClick = this.handlePoiElementClick.bind(this);
    }
    private handlePoiElementClick(poiDetails: POIModule.Types.PointOfInterestDto) {
        this.props.setActivePoi(poiDetails);
        this.props.setMapCenter({ lat: poiDetails.latitude, lng: poiDetails.longitude });
        this.props.showPoiDetails();
        this.props.setMapZoom(9);
    }
    public render() {
        return (
            <div className="poi__element">
                {this.props.poiStore.poiList.map((e: POIModule.Types.PointOfInterestDto, idx: number) => {
                    return <PoiElement key={idx} poiDetails={e} onClick={this.handlePoiElementClick} activePoi={this.props.poiStore.activePoi} t={this.props.t}/>;
                })}
                {this.props.poiStore.poiList.length == 0 && <h4 className="bold">{this.props.t('noPOI')}</h4>}
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedProps {
    return {
        poiStore: state.poiStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        getPoiList: () => dispatch(POIModule.Actions.getPoiList()),
        addPoi: (poiDetails: POIModule.Types.AddPointOfInterestRequest) => dispatch(POIModule.Actions.addPoi(poiDetails)),
        deletePoi: (poiID: number) => dispatch(POIModule.Actions.deletePoi(poiID)),
        setActivePoi: (poiDetails: POIModule.Types.PointOfInterestDto) => dispatch(POIModule.Actions.setDetailsForPoiView(poiDetails)),
        showPoiDetails: () => dispatch(POIModule.Actions.showPoiDetailsPopup()),
        setMapCenter: (center: MapModule.Types.MapCenter) => dispatch(MapModule.Actions.setMapCenter(center)),
        setMapZoom: (zoom: number) => dispatch(MapModule.Actions.setMapZoom(zoom))
    };
}
export default withTranslation('forms')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(POI) as React.ComponentType<any>
) as React.ComponentClass<Props>;

const PoiElement = (props: { poiDetails: POIModule.Types.PointOfInterestDto; onClick: Function; activePoi: POIModule.Types.PointOfInterestDto, t: (key: string) => string }) => {
    const { poiDetails, activePoi } = props;
    let classes = 'poidetails';
    if (activePoi !== null) {
        classes += activePoi.id === poiDetails.id ? ' active' : '';
    }
    return (
        <div className={classes} onClick={() => props.onClick(poiDetails)}>
            <div className="poidetails__title">
                <img src="/images/icons/poi_marker.svg" width="13" />
                <h5>{poiDetails.title}</h5>
            </div>
            <div className="poidetails__description">
                <h6 className="poidetails__heading">{props.t('address')}</h6>
                <p className="poidetails__address">
                    {poiDetails.address ? (
                        <span>{poiDetails.address}</span>
                    ) : (
                        <span>
                            {poiDetails.latitude} {poiDetails.longitude}
                        </span>
                    )}
                </p>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Map/POIManagement/POI.tsx